import { isUndefined } from 'lodash'
import { Installation } from '../../models/installation.model'
import { InstallationsDto } from '../dto/installations.dto'

const installationsDtoToModelTransformer = (values: InstallationsDto): Installation[] => {
  return (
    values?.id?.map((id, index) => ({
      accessRequestAt: values?.accessRequestAt?.[index] || undefined,
      brandType: values?.brandType?.[index] ?? undefined,
      city: values?.city?.[index] || '',
      countryCode: values?.countryCode?.[index] || '',
      createdAt: values?.createdAt?.[index] || undefined,
      createdBy: values?.createdBy?.[index] || undefined,
      createdByFirstName: values?.createdByFirstName?.[index] || undefined,
      createdByLastName: values?.createdByLastName?.[index] || undefined,
      createdByUsername: values?.createdByUsername?.[index] || undefined,
      decommissionedAt: values?.decommissionedAt?.[index] ?? undefined,
      emsMasterDeviceId: values?.emsMasterDeviceId?.[index] || undefined,
      emsMasterId: values?.emsMasterId?.[index] || -1,
      emsMasterProduct: values?.emsMasterProduct?.[index] || undefined,
      gpsLatitude: values?.gpsLatitude?.[index] || -1,
      gpsLongitude: values?.gpsLongitude?.[index] || -1,
      id: !isUndefined(id) ? Number(id) : -1,
      installationStatementId: values.installationStatementId?.[index] || undefined,
      installationStatus: values?.installationStatus?.[index] || 'error',
      isFarm: values?.isFarm?.[index] || false,
      ownerAccountId: values?.ownerAccountId?.[index] || undefined,
      ownerCompanyName: values?.ownerCompanyName?.[index] || '',
      ownerFirstName: values?.ownerFirstName?.[index] || undefined,
      ownerId: values?.ownerId?.[index] || undefined,
      ownerLastName: values?.ownerLastName?.[index] || undefined,
      ownerUsername: values?.ownerUsername?.[index] || undefined,
      partnersInstallationName: values?.partnersInstallationName?.[index] || '',
      permissionType: values?.permissionType?.[index] || undefined,
      projectName: values?.projectName?.[index] || undefined,
      streetName: values?.streetName?.[index] || '',
      streetNumber: values?.streetNumber?.[index] || '',
      timezone: values?.timezone?.[index] || '',
      updatedAt: values?.updatedAt?.[index] || undefined,
      updatedBy: values?.updatedBy?.[index] || undefined,
      zip: values?.zip?.[index] || '',
      accountLinkId: values?.accountLinkId?.[index] || undefined,
      statementStatus: values?.statementStatus?.[index] || undefined,
    })) || []
  )
}

export default installationsDtoToModelTransformer
